import { Box, Typography, LinearProgress } from "@mui/material";

export function TrilhaProgresso({ trilha }) {
  return (
    <Box>
      {trilha.map((item, index) => {
        const aulas = item.modulo.curso.playlist_items.length;
        const vistas = item.videos_vistos.filter((v) => v.visto).length;
        const progresso = Math.round((vistas / aulas) * 100);

        return (
          <Box key={index} sx={{ position: "relative" }}>
            <Typography variant="body2" mb={0.5}>
              Linha de aprendizado do curso:
            </Typography>

            {/* Barra de progresso */}
            <Box sx={{ position: "relative", width: "100%" }}>
              <LinearProgress
                variant="determinate"
                value={progresso}
                sx={{
                  height: 12,
                  borderRadius: 6,
                  backgroundColor: "#E0E0E0",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: "#F15A24",
                    borderRadius: 6,
                  },
                }}
              />

              {/* Indicador com triângulo e texto */}
              {progresso < 100 && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    position: "absolute",
                    left: `calc(${progresso}% - 110px)`,
                    top: "100%",
                    mt: 0.5,
                    width: "120px",

                    textAlign: "center",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{ color: "#F15A24", fontWeight: "bold" }}
                  >
                    Você estudou: {progresso}%
                  </Typography>
                  <Box
                    sx={{
                      width: 0,
                      height: 0,
                      borderLeft: "6px solid transparent",
                      borderRight: "6px solid transparent",
                      borderBottom: "8px solid gray",
                      margin: "0 auto",
                      transform: "translateY(-35%)",
                      mt: "2px",
                    }}
                  />
                </Box>
              )}
            </Box>

            {/* Texto padrão abaixo se progresso for 100% */}
            {progresso === 100 && (
              <Typography variant="caption" mt={0.5} fontWeight="bold">
                100%
              </Typography>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
